import { Command } from 'commander';
import { VaultRenderService } from '../../services/vault-render.service.js';
import { unlockVault } from './shared.js';

interface RenderOptions {
    agent?: boolean;
    for?: string;
    withRefs?: boolean;
    depth?: string;
    passphrase?: string;
    recoveryKey?: string;
}

export function createVaultRenderCommand(): Command {
    return new Command('render')
        .description('Render vault context for a target consumer')
        .argument('<id>', 'Vault item id')
        .option('--agent', 'Render for coding agent')
        .option('--for <target>', 'Render target (agent)')
        .option('--with-refs', 'Resolve and include referenced non-secret vault items')
        .option('--depth <number>', 'Reference depth (currently supports 1)', '1')
        .option('--passphrase <value>', 'Vault passphrase')
        .option('--recovery-key <value>', 'Recovery key')
        .action(async (id: string, options: RenderOptions) => {
            const { store, vmk } = await unlockVault(options);
            const item = await store.readPlainItem(vmk, id);
            const target = options.agent || options.for === 'agent' ? 'agent' : 'human';
            if (target === 'agent') {
                const refs = options.withRefs ? await store.resolveRefs(vmk, item) : undefined;
                console.log(new VaultRenderService().renderForAgent(item, refs));
                return;
            }
            console.log(`${item.title}\n${item.summary}`);
        });
}
